import { render, staticRenderFns } from "./WithholdingsSuppliers.vue?vue&type=template&id=1f0e562e&scoped=true"
import script from "./WithholdingsSuppliers.vue?vue&type=script&lang=js"
export * from "./WithholdingsSuppliers.vue?vue&type=script&lang=js"
import style0 from "./WithholdingsSuppliers.vue?vue&type=style&index=0&id=1f0e562e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f0e562e",
  null
  
)

export default component.exports